<template>
    <div>
        <div class="row align-items-center">
            <div class="col-auto pointer" v-if="draggable">
                <i class="fe fe-more-vertical"></i>
            </div>
            <div class="col">
                <strong>{{service.code}}</strong>
                - {{ service.label}}
                <div class="row">
                    <span class="col-auto text-muted small m-0">{{service.duration}} {{$t('min')}}</span>
                    <span class="col-auto text-muted small m-0">
                        <money class="m-0" :value="service.price"></money>
                    </span>
                </div>
            </div>

            <div class="col-auto">
                <button class="btn btn-white btn-sm mr-1" @click="removeItem(index)">
                    <i class="fe fe-x"></i>
                </button>
            </div>
        </div>

        <div class="mt-4" v-if="service.bundle && false">
            <div class="row mt-1" v-for="(bundleItem, bundleIndex) in service.bundle" :key="bundleIndex">
                <div class="col" v-if="bundleItem.type == 'product'">
                    <div class="card m-0 card-inactive" v-if="bundleItem.product.price">
                        <div class="card-body p-2 small">
                            <div class="row align-items-center">
                                <div class="col-auto">{{ bundleItem.product.label }}</div>
                                <div class="col"></div>
                                <div
                                    class="col-auto text-muted"
                                >{{ bundleItem.quantity }} x {{ bundleItem.product.price.retailPrice }}</div>

                                <div class="col-auto">
                                    <i class="fe fe-x" @click="deleteBundleItem(index, bundleIndex)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col" v-if="bundleItem.type == 'service'">
                    <div class="card m-0 card-inactive">
                        <div class="card-body p-2 small">
                            <div class="row align-items-center">
                                <div class="col-auto">{{ bundleItem.service.label }}</div>
                                <div class="col"></div>
                                <div class="col-auto text-muted">
                                    <money :value="bundleItem.service.price" />
                                </div>
                                <div class="col-auto">
                                    <i class="fe fe-x" @click="deleteBundleItem(index, bundleIndex)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Money from '@/components/Money';
export default {

    props: ['service', 'removeItem', 'deleteBundleItem', 'draggable', 'index'],
    components: {
        Money,

    },

}
</script>